/**
 * Labels for seeded configuration.
 *
 * A seeded row carries an `i18nKey` so it reads correctly in all three
 * languages; a row the coach added themselves has no key and keeps the words
 * they typed. Falling back to the stored label — rather than showing the key —
 * is what makes an org's own criteria and tests first-class.
 */
export function configLabel(
  row: { label: string; i18nKey?: string | null } | undefined,
  t: (key: string) => string,
): string {
  if (!row) return '';
  if (!row.i18nKey) return row.label;
  const translated = t(row.i18nKey);
  return translated === row.i18nKey ? row.label : translated;
}
